package com.example.mystybag.appCore.model

import com.example.mystybag.sharedmodels.project.responseModels.CityResponseModel

data class CitySelectionBottomSheetUIState(
    val cities: List<CityResponseModel> = emptyList(),
    val selectedCity: CityResponseModel? = null,
    val isLoading: Boolean = false,
    val searchText: String = ""
)
